import { Col, Form, FormCheck, Row } from "react-bootstrap";
import Select from "react-select";

const PlaylistsLiveIdent = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  identsLoading,
  identsError,
  allIdentsData,
  graphics,
  isLocked
) => {
  return (
    <>
      <Form.Group controlId="preRollLiveInfoIdentInput">
        <Row className="align-items-center pt-2 ">
          <Form.Label
            column
            sm="2"
          >
            Pre Ident:
          </Form.Label>
          <Col sm="9">
            <Form.Select
              value={programDetails.preRoll.live.introIdent.introIdent}
              size="sm"
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      introIdent: {
                        ...programDetails.preRoll.live.introIdent,
                        introIdent: e.target.value,
                        isDirty: true,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              disabled={isLocked}
              className={
                programDetails.preRoll.live.introIdent.isDirty && "text-danger"
              }
            >
              <option value="">Select an ident</option>
              {identsLoading ? (
                <option>Loading...</option>
              ) : identsError ? (
                <option>Error loading idents</option>
              ) : (
                allIdentsData &&
                allIdentsData.map((ident) => (
                  <option
                    key={ident._id}
                    value={ident._id}
                  >
                    {ident.name}
                  </option>
                ))
              )}
            </Form.Select>
          </Col>
          <Col sm="1">
            <FormCheck
              type="checkbox"
              isValid
              checked={programDetails.preRoll.live.introIdent.isDirty}
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      introIdent: {
                        ...programDetails.preRoll.live.introIdent,
                        isDirty: e.target.checked,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              disabled={isLocked}
            />
          </Col>
        </Row>
        <Row className="pt-2 mt-2  border-0 border-top align-items-center">
          <Col
            // column
            xs={2}
          >
            Graphics:
          </Col>
          <Col>
            <Select
              name="live.graphics"
              size="sm"
              isMulti
              closeMenuOnSelect={false}
              options={graphics}
              value={programDetails.preRoll.live.graphics.graphics}
              className={
                programDetails.preRoll.live.graphics.isDirty && "text-danger"
              }
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      graphics: {
                        ...programDetails.preRoll.live.graphics,
                        graphics: e,
                        isDirty: true,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              isDisabled={isLocked}
            />
          </Col>
          <Col sm="1">
            <FormCheck
              type="checkbox"
              isValid
              checked={programDetails.preRoll.live.graphics.isDirty}
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      graphics: {
                        ...programDetails.preRoll.live.graphics,
                        isDirty: e.target.checked,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              disabled={isLocked}
            />
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="preRollLiveIdentInput">
        <Row className="align-items-center pt-2 ">
          <Form.Label
            column
            sm="2"
          >
            Live Ident:
          </Form.Label>
          <Col sm="9">
            <Form.Select
              value={programDetails.preRoll.live.ident.ident}
              size="sm"
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      ident: {
                        ...programDetails.preRoll.live.ident,
                        ident: e.target.value,
                        isDirty: true,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              className={
                programDetails.preRoll.live.ident.isDirty && "text-danger"
              }
              disabled={isLocked}
            >
              <option value="">Select an ident</option>
              {identsLoading ? (
                <option>Loading...</option>
              ) : identsError ? (
                <option>Error loading idents</option>
              ) : (
                allIdentsData &&
                allIdentsData.map((ident) => (
                  <option
                    key={ident._id}
                    value={ident._id}
                  >
                    {ident.name}
                  </option>
                ))
              )}
            </Form.Select>
          </Col>
          <Col sm="1">
            <FormCheck
              type="checkbox"
              isValid
              checked={programDetails.preRoll.live.ident.isDirty}
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      ident: {
                        ...programDetails.preRoll.live.ident,
                        isDirty: e.target.checked,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              disabled={isLocked}
            />
          </Col>
        </Row>
        <Row className="pt-2 mt-2  border-0 border-top">
          <Col
            className="pt-2 "
            xs={2}
          >
            Media G:
          </Col>
          <Col>
            <Select
              name="live.media"
              size="sm"
              isMulti
              closeMenuOnSelect={false}
              options={graphics}
              value={programDetails.preRoll.live.media.media}
              className={
                programDetails.preRoll.live.media.isDirty && "text-danger"
              }
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      media: {
                        ...programDetails.preRoll.live.media,
                        media: e,
                        isDirty: true,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              isDisabled={isLocked}
            />
          </Col>
          <Col sm="1">
            <FormCheck
              type="checkbox"
              isValid
              checked={programDetails.preRoll.live.media.isDirty}
              onChange={(e) => {
                setProgramDetails({
                  ...programDetails,
                  preRoll: {
                    ...programDetails.preRoll,
                    live: {
                      ...programDetails.preRoll.live,
                      media: {
                        ...programDetails.preRoll.live.media,
                        isDirty: e.target.checked,
                      },
                    },
                  },
                });
                setFormEdited(true);
              }}
              disabled={isLocked}
            />
          </Col>
        </Row>
      </Form.Group>
    </>
  );
};
export default PlaylistsLiveIdent;
